import { ALL_EMAIL_TEMPLATES } from "../../constant/ActionType";

export default function EmailTemplatesReducer(
  state = {
    emailTemplates: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case ALL_EMAIL_TEMPLATES:
      return {
        ...state,
        emailTemplates: action.data?.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
